module.exports = __webpack_public_path__ + "img/logo_ecshopx.f59685be.png";